import { createSlice } from '@reduxjs/toolkit'
import {
  CommentTemplateType,
  createTemplate,
  deleteTemplate,
  getTemplateById,
  getTemplates,
  updateTemplate,
} from '../../actions/templatesAction'

export interface ITemplates {
  templates: CommentTemplateType[]
  currentTemplate: CommentTemplateType | null
  error: any
  isLoading: boolean
}

const initialState: ITemplates = {
  templates: [],
  currentTemplate: null,
  isLoading: false,
  error: '',
}

export const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    clearCurrentTemplate: (state) => {
      state.currentTemplate = null
    },
    clearTemplatesError: (state) => {
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTemplates.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(getTemplates.fulfilled, (state, action) => {
      state.isLoading = false
      state.templates = action.payload
      state.error = ''
    })
    builder.addCase(getTemplates.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(getTemplateById.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(getTemplateById.fulfilled, (state, action) => {
      state.isLoading = false
      state.currentTemplate = action.payload
      state.error = ''
    })
    builder.addCase(getTemplateById.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(createTemplate.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(createTemplate.fulfilled, (state, action) => {
      state.isLoading = false
      state.templates.push(action.payload)
      state.error = ''
    })
    builder.addCase(createTemplate.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(updateTemplate.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(updateTemplate.fulfilled, (state, action) => {
      state.isLoading = false
      const index = state.templates.findIndex((t) => t.id === action.payload.id)
      if (index !== -1) {
        state.templates[index] = action.payload
      }
      if (state.currentTemplate?.id === action.payload.id) {
        state.currentTemplate = action.payload
      }
      state.error = ''
    })
    builder.addCase(updateTemplate.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(deleteTemplate.pending, (state) => {
      state.isLoading = true
      state.error = ''
    })
    builder.addCase(deleteTemplate.fulfilled, (state, action) => {
      state.isLoading = false
      state.templates = state.templates.filter((t) => t.id !== action.payload)
      if (state.currentTemplate?.id === action.payload) {
        state.currentTemplate = null
      }
      state.error = ''
    })
    builder.addCase(deleteTemplate.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
  },
})

export const { clearCurrentTemplate, clearTemplatesError } = templatesSlice.actions

export const templatesReducer = templatesSlice.reducer
